import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const TrustlyOverlayBody = lazy(() => import('./TrustlyOverlayBody'/* webpackChunkName: 'TrustlyOverlayBody' */));

export default function TrustlyOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <TrustlyOverlayBody />
    </GenericFallbackSuspense>
  );
}
